import { render, staticRenderFns } from "./CameraFunc.vue?vue&type=template&id=db181c10&"
import script from "./CameraFunc.vue?vue&type=script&lang=js&"
export * from "./CameraFunc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports